export function buildIntegrationSandboxCode (integrationContainerId, moduleConfig) {
    const javascript = `(function () {
    var integrationContainer = document.getElementById('${integrationContainerId}');
    if(!integrationContainer) return;

    var guideContainer = integrationContainer;
    for(var i = 0; i < 10; i++) {
        if(guideContainer.id === 'pendo-guide-container' || guideContainer.tagName.toLowerCase() === 'body') break;

        guideContainer = guideContainer.parentElement;
    }

    if(guideContainer.id !== 'pendo-guide-container') return;

    var resourceCenter = pendo.Sizzle('#pendo-resource-center-container');
    var resourceCenterHeight = resourceCenter[0].offsetHeight;
    var guideContainerHeight = guideContainer.offsetHeight;
    var heightToFill = resourceCenterHeight - guideContainerHeight;
    integrationContainer.style.height = '100%';

    pendo.BuildingBlocks.BuildingBlockResourceCenter.launchIntegrationByNameAndProvider('${moduleConfig.integrationName}', '${moduleConfig.integrationProvider}', integrationContainer);
})()`;

    const content = {
        javascript,
        css: '',
        html: `<div id="${integrationContainerId}"></div>`,
    };

    return content;
}
